











import { tns } from "tiny-slider/src/tiny-slider";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {
        EstateCard: () => import("./card.vue")
    }
})
export default class EstatesSlider extends Vue {
    @Prop({ required: false, default: "sale" }) saleOrLet!: "sale" | "let";
    @Prop({ required: false, default: "all" }) type!: "house" | "apartment" | "parking" | "land" | "office" | "all";

    @Prop({ required: false, default: false }) excludeEstateId!: false | number;

    $refs!: Vue["$refs"] & {
        slider: HTMLElement;
    };

    slider: any = null;

    loading: boolean = false;

    params: SweepbrightParams = {
        per_page: 3,
        page: 1,
        is_project: false,
        sort: "created_at,desc",
        min: 0
    };

    estates: Estate[] = [];

    private mounted() {
        this.getEstates();
    }

    private getEstates() {
        this.loading = true;
        let params = { ...this.params, sale_or_let: this.saleOrLet };

        if (this.excludeEstateId) {
            params.exclude_estate_id = this.excludeEstateId;
        }
        if (this.type !== 'all') {
            params.type = this.type;
        }


        // @ts-ignore
        axios
            .get("/api/estates", { params: params })
            .then((response: any) => this.initSlider(response.data.data))
            .finally(() => (this.loading = false));
    }

    private initSlider(estates: Estate[]) {
        this.estates = estates;
        this.$nextTick(() => {
            this.slider = tns({
                container: this.$refs.slider,
                items: 1.1,
                gutter: 24,
                preventScrollOnTouch: "force",
                mouseDrag: true,
                loop: false,
                controls: false,
                nav: false,
                swipeAngle: false,
                responsive: {
                    1024: {
                        items: 3,
                        gutter: 32
                    }
                }
            });
        });
    }
}
